import { useEffect } from "react";
import { useContent, resolveUrl } from "@/cms/ContentContext";

/**
 * Dynamically sets the browser tab favicon and apple-touch-icon to the
 * current logo stored in the CMS. Removes any stale defaults so no old logo
 * is ever requested by the browser.
 */
export const useDynamicFavicon = () => {
  const { content } = useContent();
  const logoUrl = resolveUrl(content?.images?.logo) || "";

  useEffect(() => {
    if (!logoUrl) return;
    const head = document.head;

    // Remove any existing favicon / apple-touch-icon links
    head.querySelectorAll(
      "link[rel='icon'],link[rel='shortcut icon'],link[rel='apple-touch-icon'],link[rel='apple-touch-icon-precomposed']"
    ).forEach((el) => el.remove());

    // Insert fresh ones pointing at the current CMS logo
    const icons = [
      { rel: "icon", href: logoUrl },
      { rel: "shortcut icon", href: logoUrl },
      { rel: "apple-touch-icon", href: logoUrl },
    ];
    icons.forEach(({ rel, href }) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = href;
      head.appendChild(link);
    });
  }, [logoUrl]);
};
